module.exports = __webpack_public_path__ + "static/company-profile-cover-7851f65137ca162076c1b858ece42ab3.jpg";